<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header">
        <h1 class="gridcaption"> {{heading}} 
        <img src="./assets/images/export_black.svg"  *ngIf="export" (click)="onBtExport()" style="float: right;cursor: pointer;margin-right: 20px;"></h1>
    </div>
</header>
<div class="body" [style]="errormsg? 'margin: 0% 1% 0% 1%;':  'margin: 1% 1%;'">
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <ag-grid-angular [enableCellTextSelection]="true" style="width:100%;height: 380px;" id="LIOS-GRID" class="ag-theme-balham"
        (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
        [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
        [getRowHeight]="getRowHeight"   [context]="context" [pagination]="true"
        [paginationPageSize]="10" [icons]="icons">
    </ag-grid-angular>
    <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

        <div class="w-25 col-4 ">
            <div>
                <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                <select class="page-drpdwn" (change)="onPageSizeChanged($event)">
                    <option value="5">5</option>
                    <option value="10" selected>10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="ALL">ALL</option>
                </select>
                <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
            </div>
        </div>

        <div style="display: flex;" class="pagination_text col-4 offset-2">

            <!-- first -->
            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                first_page</mat-icon>

            <!-- previous -->
            <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                keyboard_arrow_left</mat-icon>

            <p class="total_row_text">Total Row {{rowCount}}</p>

            <!-- next -->
            <mat-icon style="cursor: pointer; margin-top: -4px;"
                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                (click)="goToNexpage()">keyboard_arrow_right
            </mat-icon>

            <!-- last -->
            <mat-icon style="cursor: pointer; margin-top: -4px;"
                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                (click)="goToLastPage()">last_page
            </mat-icon>

        </div>

    </div>
</div>